import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { ArrowRight } from '@clds/icon';
import { LinkButton } from '@clds/button';
import { messages } from '../../../i18n';
import { APPS_EXPLORER_PATH } from '../../../ApplicationWrapper.const';
import { DropdownItemNonInteractive } from '../../../components/DropdownMenuItem/DropdownMenuItem';
import { useCustomerIdContext } from '../../../context';

export const ApplicationsExplorerLink = () => {
  const { formatMessage } = useIntl();
  const { currentCustomer } = useCustomerIdContext();

  return (
    <StyledDropdownItemNonInteractive>
      <LinkButton
        href={currentCustomer && APPS_EXPLORER_PATH.replace('{customerId}', currentCustomer.externalIdForUrl)}
        size="sm"
        tone="surface"
        rightSlot={<ArrowRight size="md" />}
      >
        {formatMessage(messages.productExplorerLink)}
      </LinkButton>
    </StyledDropdownItemNonInteractive>
  );
};

const StyledDropdownItemNonInteractive = styled(DropdownItemNonInteractive)`
  a {
    text-decoration: none !important;
  }
`;
